import { http } from '@/services/http';

export interface UserInvitation {
  id: number;
  email: string;
  [key: string]: unknown;
}

export const userInvitationsApi = {
  index(): Promise<UserInvitation[]> {
    return http<UserInvitation[]>({ url: 'invitations', method: 'get' });
  },
  create(email: string): Promise<UserInvitation> {
    return http<UserInvitation>({ url: 'invitations', method: 'post', data: { email } });
  },
  remove(invitationId: number | string): Promise<void> {
    return http<void>({ url: `invitations/${invitationId}`, method: 'delete' });
  },
  resend(invitationId: number | string): Promise<unknown> {
    return http({ url: `invitations/${invitationId}/resend`, method: 'post' });
  },
};
